/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TheCargo Loadboard
 * Bridges TheCargo platform with third-party freight loadboards — Central Dispatch and Super Dispatch — for posting, listing, and synchronizing vehicle transport orders.

## Authentication

All endpoints require a JWT Bearer token:
```
Authorization: Bearer <access_token>
```

Obtain tokens via the **Auth Service** (`POST /auth/api/v1/auth/login`).

## Loadboard Accounts

Each organization may connect one or more loadboard accounts. Credentials are stored encrypted; outbound sync runs on a schedule plus on-demand triggers.

## Webhooks

Inbound webhook endpoints accept callbacks from external loadboards and emit internal RabbitMQ events that the shipment service consumes.

## Contact

For API access or issues contact **support@thecargo.io**
 * OpenAPI spec version: 1.0.0
 */

export type LoadboardTerms =
  (typeof LoadboardTerms)[keyof typeof LoadboardTerms]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoadboardTerms = {
  check_on_delivery: 'check_on_delivery',
  check_on_pickup: 'check_on_pickup',
  cash_on_pickup: 'cash_on_pickup',
  cash_on_delivery: 'cash_on_delivery',
  '2_days': '2_days',
  '5_days': '5_days',
  '7_days': '7_days',
  '10_days': '10_days',
  '15_days': '15_days',
  '20_days': '20_days',
  '30_days': '30_days',
  '45_days': '45_days',
  '60_days': '60_days',
} as const
